import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=51a0fb2c&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"
import style0 from "./shop.vue?vue&type=style&index=0&id=51a0fb2c&prod&scoped=true&lang=less"
import style1 from "./shop.vue?vue&type=style&index=1&id=51a0fb2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a0fb2c",
  null
  
)

export default component.exports